import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateThreatsBreakdown = document.createElement('template');

templateThreatsBreakdown.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-1-3-ratio">
    <h2 class="widget-title display-2">
        <span id="threatsBreakdownTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content threats-breakdown-container">

        <div class="chart-content">
            <div id="threatsBreakdownChart" class="incidents-chart"></div>
            <div class="chart-empty donut-chart-error"><span class="display-1">--</span></div>
        </div>

       <ul id="threatsBreakdownList" class="list-unstyled chart-legend">
          <li class="gz-data-item" gz-threats-breakdown="workstationNo">
              <span class="gz-data-item--bullet" gz-list-element="breakdownColor"></span>

              <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="breakdownName"></div>
                <span class="gz-data-item--value text-center" gz-list-element="breakdownValue"></span>
              </div>

          </li>
          <li class="gz-data-item" gz-threats-breakdown="serversNo">
              <span class="gz-data-item--bullet" gz-list-element="breakdownColor"></span>

              <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="breakdownName"></div>
                <span class="gz-data-item--value text-center" gz-list-element="breakdownValue"></span>
              </div>
          </li>
          <li class="gz-data-item" gz-threats-breakdown="containerHostsNo">
              <span class="gz-data-item--bullet" gz-list-element="breakdownColor"></span>

              <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="breakdownName"></div>
                <span class="gz-data-item--value text-center" gz-list-element="breakdownValue"></span>
              </div>
          </li>
          <li class="gz-data-item" gz-threats-breakdown="containersNo">
              <span class="gz-data-item--bullet" gz-list-element="breakdownColor"></span>

              <div class="gz-data-item--details item-details">
                <div class="gz-data-item--title" gz-list-element="breakdownName"></div>
                <span class="gz-data-item--value text-center" gz-list-element="breakdownValue"></span>
              </div>
          </li>
      </ul>

      <gz-loader class="widget-loading" rows="5"></gz-loader>
    </div>
  </div>
`;
